<template>
    <a v-if="href" :href="href" class="row-link" @click="onClick">
        <slot name="default"></slot>
    </a>
    <slot name="default" v-else></slot>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Inject } from '@/helpers/Decorators';

// Wraps cell content in a real <a href> so the browser offers "open in new tab".
// A plain left click is still handled by the list's `row-click`; modified clicks
// (Ctrl/Cmd/Shift) are left to the browser and must not also trigger `row-click`.
@Options({
    name: 'row-link'
})
export default class RowLink extends Vue
{
    @Inject('loaded')
    public loaded: boolean;

    @Inject('layout')
    public layout: string;

    @Inject('row-link')
    public rowLink: (item: any) => any;

    @Inject('item')
    public item: any;

    public get href(): string | null
    {
        if (!this.loaded || this.layout !== 'table' || !this.rowLink)
        {
            return null;
        }

        const location = this.rowLink(this.item);

        if (!location)
        {
            return null;
        }

        try
        {
            return this.$router.resolve(location).href;
        }
        catch
        {
            // unresolvable location (e.g. unknown route name) -> no link, row-click still works
            return null;
        }
    }

    public onClick(event: MouseEvent): void
    {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)
        {
            event.stopPropagation();

            return;
        }

        event.preventDefault();
    }
}
</script>

<style lang="scss">
// Stretch the link over the whole cell so the context menu works anywhere in it.
td:has(> a.row-link) {
    position: relative;
}

a.row-link {
    color: inherit;
    text-decoration: none;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
    }
}
</style>
